import Vue from 'vue';
import Vuex from 'vuex';

import actions from './actions';
Vue.use(Vuex);

const store=new Vuex.Store({
    state:{
        endpoint:process.env.VUE_APP_ENDPOINT,
        loading:{
            status:false,
            msg:''
        }
    },
    actions
});

export default store;